import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { VehiclesImportedHistoryModel } from './typings/vehicles.imported-history';

@Component({
  selector   : 'wor-vehicle-imported-history-notes',
  template: require('./vehicle.imported-history.notes.component.html')
})
export class VehicleImportedHistoryNotesComponent {
  @Input() history: VehiclesImportedHistoryModel = {} as VehiclesImportedHistoryModel;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
